import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaTypedSchemaNode } from './TypedNode'
import { SchemaTypedSchemaModel } from './ViewModel'

export const SchemaTypedSchemaPlugin = createSchemaPlugin(
  'Schema.TypedSchema',
  SchemaTypedSchemaModel,
  SchemaTypedSchemaNode
)
